module.exports = __webpack_public_path__ + "img/maps-and-location.9e863305.png";